<template>
  <div>
    <div style="display: flex; margin-bottom: 1.5rem;">
      <div style="flex-grow: 1;">
        <search-bar-wrapper
          :key='updateSearch'
          :search-items="list" 
          :options="searchOptions" 
          v-bind:filter.sync="filterSearch"
          v-model="searchResults">
        </search-bar-wrapper>
      </div>
    </div>

    <cc-security role="dashboard..entity.create">
      <button class="cc-banner-button text-uppercase" data-testid="btnAddDashboard" @click="newDashboard">
        <i style="font-size: 1.4rem; margin-right: 5px;" class="fa fa-plus-circle"></i>
        {{ $t('dashboard:button.add_dashboard', 'Add Dashboard') }}
      </button>
    </cc-security>
    <b-overlay :show="tableIsLoading" spinner-variant="primary" rounded="sm" :opacity="0.4">
      <v-server-table
        ref="dashboard-table"
        data-testid="tblDashboardList"
        v-if="!fatalError && loaded"
        :data="searchResults"
        :columns="columns" 
        :options="options"
      >

        <div role="group" slot="labels" slot-scope="props" class="d-flex" data-testid="tblDashboardLabels">
          <span
            v-for="label in props.row.labels"
            v-bind:key="label"
            class="dashboard-label"
          >
            <b-badge variant="primary">
              {{label}}
            </b-badge>
          </span>
        </div>

        <div role="group" slot="name" slot-scope="props" class="d-flex">
          <router-link :to="{ name: 'EditDashboard', params: { slug: props.row.slug }}">
            {{props.row.name}}
          </router-link>
        </div>
        <div role="group" slot="created_ts" slot-scope="props" class="d-flex">
          <span :id="props.row.slug + 'createdts'">
            {{getEventTimeWords(props.row.created_ts)}}
          </span>
          <b-tooltip :target="props.row.slug + 'createdts'" triggers="hover">
            {{getEventTimeDate(props.row.created_ts)}}
          </b-tooltip>
        </div>
        <div role="group" slot="updated_ts" slot-scope="props" class="d-flex">
          <span :id="props.row.slug + 'updatedts'">
            {{getEventTimeWords(props.row.updated_ts)}}
          </span>
          <b-tooltip :target="props.row.slug + 'updatedts'" triggers="hover">
            {{getEventTimeDate(props.row.updated_ts)}}
          </b-tooltip>
        </div>

        <div role="group" slot="actions" slot-scope="props" class="d-flex">
          <b-dropdown variant="link" class="m-md-2" no-caret data-testid="mnuActions"
            v-if="$s.can.access(['dashboard..entity.read', 'dashboard..entity.update']) || $s.can.access('dashboard..entity.delete')"
          >
              <template #button-content>
                  <i class="fa fa-ellipsis-h"></i>
              </template>
              <b-dropdown-item v-if="$s.can.access(['dashboard..entity.read', 'dashboard..entity.update'])" data-testid="mniActionsEdit" class="text-lowercase" @click="openDashboard(props.row.slug)">
                {{ $t("common:single_word.edit", "edit") }}
              </b-dropdown-item>
              <b-dropdown-item v-if="$s.can.access('dashboard..entity.delete')" data-testid="mniActionsDelete" class="text-lowercase" @click="deleteDashboard(props.row.id)">
                {{ $t("common:single_word.delete", "delete") }}
              </b-dropdown-item>
          </b-dropdown>
        </div>


      </v-server-table>
    </b-overlay>

    <cc-error :show="loaded && fatalError" @click="init"/>

  </div>
</template>

<style>
.cc-banner-button {
    height: 46px;
    margin-bottom: 1.5rem;
    background: #ddedff;
    border: 2px dashed #417eca;
    width: 100%;
    display: flex;
    font-size: 1rem;
    align-items: center;
    justify-content: center;
}
.cc-banner-button:hover {
    background: #c5e0fb;
}

.table-responsive, .VueTables__table{
  overflow-x:visible!important;
}

.VueTables__limit-field > label, .VueTables__search-field > label {
    display: inline-block !important;
    margin-right: 10px !important;
}

.VueTables__table{
    background-color: white;
}

.dashboard-label {
  margin: .25rem;
}
</style>

<script>
import api from "../api";
import SearchBarWrapper from "../components/SearchBarWrapper";
import Vue from 'vue';
import { ClientTable, ServerTable } from 'vue-tables-2';

Vue.use(ClientTable);
Vue.use(ServerTable);


export default {
  name: 'dashboard',
  components: {
    // TileView
    SearchBarWrapper
  },
  data() {
    return {
      fatalError: false,
      loaded: false,
      dashboards: [],
      list: [],
      searchResults: [],

      //For search bar
      searchOptions : {
        group_display_limit: 10,
        filter_static_display : false,
        filter_display : false,
        init_filters : null,
        key_identifier: "id",
        empty_search_returns_nothing: false,
        non_word_characters_not_trimmed: ['.','%','(',')', '|', '"']
      },
      updateSearch: 0,
      filterSearch: false,

      //Table options
      columns: ['name', 'labels', 'created_by_name', 'created_ts', 'updated_by_name', 'updated_ts', 'actions'],
      staticOptions: {
            
        headings: {
          name: (h) => { return this.$t('common:single_word.name', 'Name'); },
          labels: (h) => { return this.$t('common:single_word.labels', 'Labels'); },
          created_by_name: (h) => { return this.$t('common:phrase.created_by', 'Created By'); },
          created_ts: (h) => { return this.$t('common:single_word.created_ts', 'Created'); },
          updated_by_name: (h) => { return this.$t('common:phrase.updated_by', 'Updated By'); },
          updated_ts: (h) => { return this.$t('common:single_word.updated_ts', 'Updated'); },
          actions: (h) => { return this.$t('common:table.actions_header', 'Actions'); }
        },
        sortIcon: {
          base : 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc'
        },
        orderBy: { 
          ascending: true,
          column: "name"
        },
        sortable: ["name", 'created_ts', 'updated_ts' ],
        filterable: false,
        customSorting: {
          created_ts: function (ascending) {
            return function (a, b) {
              if(ascending){
                return Number(a.created_ts) >= Number(b.created_ts) ? 1 : -1
              }else{
                return Number(a.created_ts) < Number(b.created_ts) ? 1 : -1
              }
            }
          },
          updated_ts: function (ascending) {
            return function (a, b) {
              if(ascending){
                return Number(a.updated) >= Number(b.updated) ? 1 : -1
              }else{
                return Number(a.updated) < Number(b.updated) ? 1 : -1
              }
            }
          }
        },
      },

      tableIsLoading: false,

    };
  },
  computed: {
    options: function() {
      return {
        requestFunction : this.getPageDetails,
        texts: this.$MessageUtil().vue_table_texts,
        ... this.staticOptions
      }
    },
  },
  watch: {
  },
  methods: {
    init() {
      this.loaded = false;
      this.fatalError = false;

      const promise = api.getDashboards({
        vendor: this.$Session.vendor,
        organizationId: this.$Session.organization_id,
        brief: true,
      });
      
      promise.then(async(res) => {
        let list = res.data;
        let userDisplayNames = await this.getUserNames(list);
        for (let d of list) {
          d.created_by_name = userDisplayNames[d.created_by];
          d.updated_by_name = d.updated_by ? userDisplayNames[d.updated_by] : '';
        }
        
        this.list = list;
        this.loaded = true;
        this.$nextTick(() => {
          this.$watch('searchResults', (newVal, oldVal) => {
            this.$refs['dashboard-table'].refresh();
          })
        })
      });
      
      promise.catch(err => {
        console.error(err);
        this.fatalError = true;
        this.loaded = true;
      });
    },
    newDashboard() {
      this.$router.push({ name: 'CreateDashboard' });
    },
    openDashboard(slug) {
      this.$router.push({ name: 'EditDashboard', params: { slug } });
    },
    async deleteDashboard(id) {
      try {
        await api.deleteDashboard({
          vendor: this.$Session.vendor,
          organizationId: this.$Session.organization_id,
          dashboardId: id
        });
        this.$Toastr = {
          message : this.$t('dashboard:toastr.delete.success', 'Dashboard successfully deleted'),
          type : 'success'
        }
        this.list = this.list.filter(db => db.id !== id);
      } catch(err) {
        console.error(err);
        this.$Toastr = {
          message : this.$t('dashboard:toastr.delete.error', 'Failed to delete dashboard'),
          type : 'error'
        }
      }
    },
    async getPageDetails(data){
      this.tableIsLoading = true;
      const { limit, ascending, page, orderBy } = data;
      let tableData = [...this.searchResults].sort((a,b)=>{
        if(ascending){
          return a[orderBy] > b[orderBy] ? 1 : -1
        }else{
          return a[orderBy] <= b[orderBy] ? 1 : -1
        }
      })
      tableData = [...tableData.splice( (page-1)*limit, limit )];

      try{
        this.tableIsLoading = false;
        return ({
          data : tableData,
          count : this.searchResults.length
        })
      }catch(err){
        console.error(err)
        this.tableIsLoading = false;
        this.fatalError = true
      }
    },
    async getUserNames(dashboards) {
      let uniqueIds = [];
      for (let d of dashboards) {
        if (!uniqueIds.includes(d.created_by)) uniqueIds.push(d.created_by);
        if (d.updated_by && d.updated_by !== d.created_by)
          if (!uniqueIds.includes(d.updated_by)) uniqueIds.push(d.updated_by);
      }

      let users = await Promise.all(uniqueIds.map(id => api.getUser({id})));

      let userObj = {};
      for (let user of users) {
        userObj[user.data.kc_id] = this.getDisplayName(user.data);
      }

      return userObj;
    },
    getDisplayName(user) {
      if (user.firstName && user.lastName) return`${user.firstName} ${user.lastName}`;
      if (user.firstName) return user.firstName;
      if (user.lastName) return user.lastName;
      return user.username;
    },
    getEventTimeWords(event_ts) {
      if (!event_ts) return '';

      let event_date = new Date(event_ts);
      let now = new Date();
      let time_diff = now - event_date;
      
      if (time_diff < 0) return '';

      let years = Math.floor(time_diff / (1000 * 60 * 60 * 24 * 7 * 52));
      if (years == 1) return this.$t("common:time.last_year", "last year");
      if (years > 0) return `${years} ${this.$t("common:single_word.years", "years")} ${this.$t("common:single_word.ago", "ago")}`;

      let months = Math.floor(time_diff / (1000 * 60 * 60 * 24 * 30));
      if (months == 1) return this.$t("common:time.last_month", "last month");
      if (months > 0) return `${months} ${this.$t("common:single_word.months", "months")} ${this.$t("common:single_word.ago", "ago")}`;

      let weeks = Math.floor(time_diff / (1000 * 60 * 60 * 24 * 7));
      if (weeks == 1) return this.$t("common:time.last_week", "last week");
      if (weeks > 0) return `${weeks} ${this.$t("common:single_word.weeks", "weeks")} ${this.$t("common:single_word.ago", "ago")}`;

      let days = Math.floor(time_diff / (1000 * 60 * 60 * 24));
      if (days == 1) return this.$t("common:time.yesterday", "yesterday");
      if (days > 0) return `${days} ${this.$t("common:single_word.days", "days")} ${this.$t("common:single_word.ago", "ago")}`;

      let hours = Math.floor(time_diff / (1000 * 60 * 60));
      if (hours == 1) return this.$t("common:time.an_hour_ago", "an hour ago");
      if (hours > 0) return `${hours} ${this.$t("common:single_word.hours", "hours")} ${this.$t("common:single_word.ago", "ago")}`;

      let minutes = Math.floor(time_diff / (1000 * 60));
      if (minutes == 1) return this.$t("common:time.a_minute_ago", "a minute ago");
      if (minutes > 0) return `${minutes} ${this.$t("common:single_word.minutes", "minutes")} ${this.$t("common:single_word.ago", "ago")}`;

      let seconds = Math.floor(time_diff / (1000));
      if (seconds == 1) return this.$t("common:time.a_second_ago", "a second ago");
      else return `${seconds} ${this.$t("common:single_word.seconds", "seconds")} ${this.$t("common:single_word.ago", "ago")}`;

    },
    getEventTimeDate(event_ts) {
      let date = new Date(event_ts);
      return date.toLocaleString();
    }

  },
  mounted() {
    if (!this.$store.state.stations && !this.$store.state.stationsError && !this.$store.state.stationsLoading) {
      this.$store.dispatch('refreshStations', {
        vendor: this.$Session.vendor,
        organizationId: this.$Session.organization_id,
        resourceId: this.$Session.sub,
      });
    }

    this.init();
  }
};
</script>
